<template>
  <div
    class="pages"
    :style="{
      backgroundColor: curIndex == 1 ? '#f5f6f9' : '#fff',
    }"
  >
    <div class="pl16 pr16" style="background: #fff">
      <jd-tip>
        <div>1.云起互动数据由云起云舟系统计算，京东互动数据来源于京东平台</div>
        <div>2.云起/京东互动数据因统计口径不同无法进行直接比较</div>
        <div>
          3.云起数据中的交易数据仅统计入会会员的数据，非会员的交易数据无法统计
          云起互动数据统计开始时间为25年11月07日，在此之前创建的活动不统计云起互动数据
        </div>
      </jd-tip>
    </div>
    <div class="flex-spc-x" style="padding: 16px; background: #ffffff">
      <div class="operate-wrap">
        <jd-subTab :options="tabInfo" @input="handleClick" :value="curIndex">
        </jd-subTab>
        <!-- AI分析 -->
        <aiToolsBtn
          v-if="rowData.status == 3"
          :sendData="[
            { activityName: rowData.activityName, activityId: rowData.id },
          ]"
        />
      </div>
      <div class="flexc-cen-x">
        <div class="target-box">
          <div
            class="target-item"
            :class="{ 'active-target': targetUserInex == index }"
            v-for="(item, index) in targetList"
            :key="index"
            @click="changeTargetUser(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
        <el-select
          v-model="queryType"
          placeholder="请选择"
          :disabled="[13, 14, 15].includes(rowData.activityType)"
          @change="changeQueryType"
          style="width: 118px; margin-left: 8px"
        >
          <el-option label="按汇总查询" value="0"> </el-option>
          <el-option label="按渠道查询" value="1"> </el-option>
        </el-select>
        <jd-button
          type="blue"
          style="margin-left: 8px"
          @click="control = true"
          :styleTextObj="{ height: '30px' }"
          >导出数据</jd-button
        >
      </div>
    </div>
    <div v-show="queryType == '0'">
      <!-- 活动概览 -->
      <div
        class="activity-overview"
        v-show="curIndex == 1 || curIndex == 2"
        style="position: relative; min-height: 400px"
        :class="curIndex == 2 ? 'pl16 pr16' : ''"
      >
        <div
          v-if="activityOverviewLoading"
          style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 10;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
          "
        >
          <jd-loading-new v-if="activityOverviewLoading" />
        </div>
        <jd-form
          style="background: #fff;border-radius: 4px;overflow: hidden;padding: 0 16px;"
          v-show="curIndex == 1"
          key="yunqiStats-activityOverview"
          :formInfo="activityOverviewInfo"
          :formData.sync="activityOverviewParams"
          immediately
          emitReset
          isreData
          @reset="activityOverviewReset"
          @search="getyunqiStatsActivityOverview"
        >
        </jd-form>
        <jd-form
          v-show="curIndex == 2"
          key="openCardConversionOverview"
          :formInfo="openCardConversionOverviewInfo"
          :formData.sync="openCardConversionOverviewParams"
          immediately
          emitReset
          isreData
          @reset="openCardConversionOverviewReset"
          @search="getyunqiStatsOpenCardConversionOverview"
        >
          <template #orderAmount="{ form }">
            <div class="flexc-cen-x">
              <el-select
                v-model="form.orderAmountType"
                placeholder="请选择"
                style="width: 150px"
              >
                <el-option label="累计付款金额" value="0"> </el-option>
                <el-option label="累计完成金额" value="1"> </el-option>
              </el-select>
              <el-select
                v-model="form.orderAmountCompareType"
                placeholder="请选择"
                style="width: 120px; margin: 0 10px"
              >
                <el-option label="大于等于" value="0"> </el-option>
                <el-option label="小于等于" value="1"> </el-option>
              </el-select>
              <el-input
                v-model="form.orderAmountCompareValue"
                placeholder="请输入"
                style="width: 120px"
                @input="
                  form.orderAmountCompareValue = getNumberData(
                    1,
                    $event,
                    1,
                    0,
                    99999,
                  )
                "
              ></el-input>
            </div>
          </template>
        </jd-form>
        <div v-if="curIndex != 1">
          <jd-title label="数据概况" style="padding-top: 30px"></jd-title>
        </div>
        <!-- 数据概览新图 -->
        <div
          style="background-color: #fff; padding-left: 44px"
          class="pb16 pt20"
        >
          <div
            class="overview-box"
            v-if="curIndex == 1 && !activityOverviewLoading"
          >
            <img
              class="line-img"
              src="https://cdn-image.yucrm.cn//hd/images/13315956_2f4501165c0d44f69cb0764c169c6d88.png"
            />
            <div
              class="overview-content-row"
              v-for="(item, index) in overviewConfigDataChart"
              :key="index"
              :style="{
                left: 350 - item.titleImgWidth / 2 + 'px',
                top: index * 165 + 'px',
                width: `calc(100% - ${350 - item.titleImgWidth / 2}px)`,
              }"
            >
              <div
                class="row-title"
                :style="{
                  backgroundImage: `url(${item.titleImg})`,
                  width: item.titleImgWidth + 'px',
                  height: item.titleImgHeight + 'px',
                }"
              >
                <div>
                  {{ item.title }}
                </div>
                <div class="title-value" v-if="item.titleValue">
                  <statistics-item
                    :item="item.titleValue"
                    :data="activityOverviewData"
                    :type="2"
                  ></statistics-item>
                </div>
              </div>
              <div
                class="overview-item-list"
                :style="{
                  backgroundColor: item.backgroundColor,
                  marginLeft: `-${item.titleImgWidth / 2 - 12}px`,
                }"
              >
                <div
                  class="overview-item"
                  v-for="(value, valueIndex) in item.itemList"
                  :key="valueIndex"
                >
                  <div class="overview-item-values">
                    <statistics-item
                      :item="value"
                      :data="activityOverviewData"
                      :type="2"
                    ></statistics-item>
                  </div>
                  <div
                    class="item-line"
                    v-if="valueIndex != item.itemList.length - 1"
                  ></div>
                </div>
              </div>
            </div>
            <!-- 访客_成交转化率   -->
            <div class="completeConversionRate-item">
              <statistics-item
                :item="{
                  label: '访客-成交转化率',
                  prop: 'completeConversionRate',
                  tips: '完成人数/活动UV',
                }"
                :data="activityOverviewData"
                :type="2"
              ></statistics-item>
            </div>
            <!-- 访客-付款转化率 -->
            <div class="payConversionRate-item">
              <statistics-item
                :item="{
                  label: '访客-付款转化率',
                  prop: 'payConversionRate',
                  tips: '付款人数/活动UV',
                }"
                :data="activityOverviewData"
                :type="2"
              ></statistics-item>
            </div>
            <!-- 下单-成交转化率 -->
            <div class="orderCompleteConversionRate-item">
              <statistics-item
                :item="{
                  label: '下单-成交转化率',
                  prop: 'orderCompleteConversionRate',
                  tips: '完成人数/下单人数',
                }"
                :data="activityOverviewData"
                :type="2"
              ></statistics-item>
            </div>
          </div>
        </div>
        <div
          v-for="(item, index) in fileConfigData"
          :key="index"
          v-show="curIndex != 1"
        >
          <div
            style="color: #333333; font-size: 14px; font-weight: bold"
            :style="{
              marginTop: index == 0 ? '24px' : '40px',
            }"
          >
            {{ item.name }}
          </div>
          <div
            class="flexc-cen-x"
            v-for="(lineItem, lineIndex) in item.itemList"
            :key="lineIndex"
          >
            <statistics-item
              v-for="(value, valueIndex) in lineItem"
              :key="valueIndex"
              :item="value"
              :data="
                curIndex == 2
                  ? openCardConversionOverviewData
                  : activityOverviewData
              "
            ></statistics-item>
          </div>
        </div>
        <template v-if="curIndex == 1 && !activityOverviewLoading">
          <!-- 店铺分析 -->
          <div class="mt16 flexc-cen-x" style="justify-content: space-between">
            <el-card
              v-for="(item, index) in shopAnalysisList"
              :key="index"
              style="width: calc(33.33% - 10px)"
            >
              <div style="font-weight: 500; font-size: 16px; color: #333333">
                {{ item.title }}
              </div>
              <div
                class="flexc-cen-x mt24"
                :style="{
                  justifyContent:
                    item.values.length == 2 ? 'space-between' : 'center',
                }"
              >
                <div
                  style="width: 200px; height: 100px; overflow: hidden"
                  v-for="(item2, index2) in item.values"
                  :key="index2"
                >
                  <shop-half-ring
                    :item="item2"
                    :title="item2.label"
                    :value="activityOverviewData[item2.prop] || 0"
                    :color="item.color[index2]"
                  />
                </div>
              </div>
              <div class="prop-list">
                <div
                  class="prop-list-item"
                  v-for="(item2, index2) in item.propList"
                  :key="index2"
                >
                  <statistics-item
                    :item="item2"
                    :data="activityOverviewData"
                    :type="2"
                  ></statistics-item>
                </div>
              </div>
            </el-card>
          </div>
          <!-- 锚点 -->
          <div style="background-color: #fff" class="mt16 pt16">
            <el-tabs v-model="activeName" @tab-click="handleClick2">
              <el-tab-pane label="中奖分析" name="prizeAnalysis"></el-tab-pane>
              <el-tab-pane label="退款分析" name="refundAnalysis"></el-tab-pane>
              <el-tab-pane
                label="商品分析"
                name="productAnalysis"
              ></el-tab-pane>
              <el-tab-pane label="趋势分析" name="trendAnalysis"></el-tab-pane>
              <el-tab-pane label="参与分析" name="participationAnalysis"></el-tab-pane>
            </el-tabs>
          </div>
          <!-- 中奖分析 -->
          <div id="prizeAnalysis" class="mt16">
            <el-card>
              <div style="font-size: 16px; font-weight: 500; color: #333333">
                中奖分析
              </div>
              <div class="flexc-cen-x">
                <div
                  class="prize-card mr16"
                  v-for="(item, index) in prizeAnalysisData"
                  :key="index"
                >
                  <shop-half-ring
                    :item="item.data"
                    :value="activityOverviewData[item.data.prop] || 0"
                    :color="item.color"
                    :type="2"
                    chartWidth="155"
                    chartHeight="155"
                  />
                  <div style="margin-left: 40px">
                    <div
                      class="flexc-cen-x"
                      :class="childIndex == 1 ? 'mt24' : ''"
                      v-for="(child, childIndex) in item.children"
                      :key="childIndex"
                    >
                      <span style="font-size: 14px; color: #666666">{{
                        child.label
                      }}</span>
                      <el-tooltip
                        placement="right"
                        width="200"
                        effect="light"
                        trigger="hover"
                        :content="child.tips"
                      >
                        <i class="new-icon-box" style="margin-left: 4px"></i>
                      </el-tooltip>
                      <span
                        class="ml16"
                        style="
                          font-weight: 500;
                          font-size: 16px;
                          color: #333333;
                        "
                      >
                        {{ activityOverviewData[child.prop] || 0 }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
          <!-- 退款分析 && 商品分析 -->
          <div v-for="(data, dataIndex) in AnalysisDataList" :key="dataIndex">
            <div :id="data.id" class="mt16">
              <el-card>
                <div style="font-size: 16px; font-weight: 500; color: #333333">
                  {{ data.title }}
                </div>
                <div class="flexc-cen-x">
                  <div
                    class="refundAnalysis-card"
                    :class="item.isShowCharts ? 'charts-item' : ''"
                    v-for="(item, index) in data.data"
                    :key="index"
                  >
                    <shop-half-ring
                      class="mr16"
                      v-if="item.isShowCharts"
                      :item="item.data"
                      :value="activityOverviewData[item.data.prop] || 0"
                      :color="item.color"
                      :icon="item.icon"
                      :type="2"
                      chartWidth="64"
                      chartHeight="64"
                    />
                    <statistics-item
                      :item="item.data"
                      :data="activityOverviewData"
                      :type="2"
                    ></statistics-item>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </template>

        <el-card style="margin-top: 16px" id="trendAnalysis">
          <jd-title label="趋势分析"></jd-title>
          <div
            class="trend-analysis"
            :style="{ height: curIndex == 1 ? '220px' : 'auto' }"
          >
            <div
              class="trend-item"
              v-for="(item, index) in fileConfigData"
              :key="index"
            >
              <div class="trend-item-title">{{ item.name }}</div>
              <div class="trend-item-content">
                <div
                  class="trend-item-content-item"
                  v-for="(lineItem, lineIndex) in item.itemList"
                  :key="lineIndex"
                >
                  <div
                    class="trend-item-content-item-value"
                    v-for="(value, valueIndex) in lineItem"
                    :key="valueIndex"
                  >
                    <el-checkbox
                      v-model="value.checked"
                      @change="initCharts"
                      :disabled="trendCheckList.length >= 4 && !value.checked"
                    >
                      {{ value.label }}
                    </el-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="color: #333333; font-size: 14px; margin-top: 16px">
            <span>已选：</span>
            <span style="color: #3159ff">{{ trendCheckList.length }}</span>
            <span>/4</span>
          </div>
          <div ref="trendChart" class="chart"></div>
        </el-card>
        <el-card style="margin-top: 16px" id="participationAnalysis">
          <div class="flexc">
            <div class="participate-analysis">
              <div class="participate-analysis-title">活动PV</div>
              <div class="participate-analysis-content">
                <number-animation
                  autoplay
                  :startVal="0"
                  :endVal="Number(activityOverviewData.activityPv) || 0"
                  :decimals="getDecimalPlaces(activityOverviewData.activityPv)"
                  separator=","
                  :duration="1000"
                />
              </div>
              <div class="participate-analysis-line"></div>
              <div class="participate-analysis-footer">
                <span>小程序PV：</span>
                <number-animation
                  autoplay
                  :startVal="0"
                  :endVal="Number(activityOverviewData.miniProgramActivityPv) || 0"
                  :decimals="getDecimalPlaces(activityOverviewData.miniProgramActivityPv)"
                  separator=","
                  :duration="1000"
                />
                <div class="participate-analysis-footer_line"></div>
                <span>活动部件PV：</span>
                <number-animation
                  autoplay
                  :startVal="0"
                  :endVal="Number(activityOverviewData.widgetActivityPv) || 0"
                  :decimals="getDecimalPlaces(activityOverviewData.widgetActivityPv)"
                  separator=","
                  :duration="1000"
                />
              </div>
            </div>
            <div class="participate-analysis ml16">
              <div class="participate-analysis-title">活动UV</div>
              <div class="participate-analysis-content">
                <number-animation
                  autoplay
                  :startVal="0"
                  :endVal="Number(activityOverviewData.activityUv) || 0"
                  :decimals="getDecimalPlaces(activityOverviewData.activityUv)"
                  separator=","
                  :duration="1000"
                />
              </div>
              <div class="participate-analysis-line"></div>
              <div class="participate-analysis-footer">
                <span>小程序UV：</span>
                <number-animation
                  autoplay
                  :startVal="0"
                  :endVal="Number(activityOverviewData.miniProgramActivityUv) || 0"
                  :decimals="getDecimalPlaces(activityOverviewData.miniProgramActivityUv)"
                  separator=","
                  :duration="1000"
                />
                <div class="participate-analysis-footer_line"></div>
                <span>活动部件UV：</span>
                <number-animation
                  autoplay
                  :startVal="0"
                  :endVal="Number(activityOverviewData.widgetActivityUv) || 0"
                  :decimals="getDecimalPlaces(activityOverviewData.widgetActivityUv)"
                  separator=","
                  :duration="1000"
                />
              </div>
            </div>
            <div class="participate-analysis ml16">
              <div class="participate-analysis-title">参与次数</div>
              <div class="participate-analysis-content">
                <number-animation
                  autoplay
                  :startVal="0"
                  :endVal="Number(activityOverviewData.participateCount) || 0"
                  :decimals="getDecimalPlaces(activityOverviewData.participateCount)"
                  separator=","
                  :duration="1000"
                />
              </div>
              <div class="participate-analysis-line"></div>
              <div class="participate-analysis-footer">
                <span>活动参与：</span>
                <number-animation
                  autoplay
                  :startVal="0"
                  :endVal="Number(activityOverviewData.miniProgramParticipateCount) || 0"
                  :decimals="getDecimalPlaces(activityOverviewData.miniProgramParticipateCount)"
                  separator=","
                  :duration="1000"
                />
                <div class="participate-analysis-footer_line"></div>
                <span>活动部件参与：</span>
                <number-animation
                  autoplay
                  :startVal="0"
                  :endVal="Number(activityOverviewData.widgetParticipateCount) || 0"
                  :decimals="getDecimalPlaces(activityOverviewData.widgetParticipateCount)"
                  separator=","
                  :duration="1000"
                />
              </div>
            </div>
            <div class="participate-analysis ml16">
              <div class="participate-analysis-title">参与人数</div>
              <div class="participate-analysis-content">
                <number-animation
                  autoplay
                  :startVal="0"
                  :endVal="Number(activityOverviewData.participateUserCount) || 0"
                  :decimals="getDecimalPlaces(activityOverviewData.participateUserCount)"
                  separator=","
                  :duration="1000"
                />
              </div>
              <div class="participate-analysis-line"></div>
              <div class="participate-analysis-footer">
                <span>活动参与：</span>
                <number-animation
                  autoplay
                  :startVal="0"
                  :endVal="Number(activityOverviewData.miniProgramParticipateUserCount) || 0"
                  :decimals="getDecimalPlaces(activityOverviewData.miniProgramParticipateUserCount)"
                  separator=","
                  :duration="1000"
                />
                <div class="participate-analysis-footer_line"></div>
                <span>活动部件参与：</span>
                <number-animation
                  autoplay
                  :startVal="0"
                  :endVal="Number(activityOverviewData.widgetParticipateUserCount) || 0"
                  :decimals="getDecimalPlaces(activityOverviewData.widgetParticipateUserCount)"
                  separator=","
                  :duration="1000"
                />
              </div>
            </div>
          </div>
        </el-card>
      </div>
      <prizeList
        class="pl16 pr16"
        :activityId="rowData.id"
        :list="prizeList"
        v-show="curIndex == 3"
      ></prizeList>
    </div>
    <!-- 渠道 -->
    <div v-show="queryType == '1'">
      <prizeList
        :activityId="rowData.id"
        :list="prizeList"
        v-show="curIndex == 3"
      ></prizeList>
      <qudao
        ref="qudaoRef"
        :rowData="rowData"
        :queryType="queryType"
        :targetUser="targetUserInex"
        :curIndex="curIndex"
        :defaultOrderStartTime="defaultOrderStartTime"
        :defaultOrderEndTime="defaultOrderEndTime"
        :activityOverviewData="activityOverviewData"
        :openCardConversionOverviewData="openCardConversionOverviewData"
        style="margin-top: 16px"
      ></qudao>
    </div>
    <!-- 生成报表 -->
    <generate
      :control="control"
      v-if="control"
      @transData="(val) => (control = val)"
      @transData1="exportData"
    >
    </generate>
  </div>
</template>

<script>
import {
  yunqiStatsActivityOverview,
  yunqiStatsActivityOverviewTrend,
  openCardConversionOverview,
  prizeSendOverview,
  yunqiStatsExport,
} from "@/api/marketing/acitivityReview.js";
import qudao from "./qudao.vue";
import statisticsItem from "./statisticsItem.vue";
import shopHalfRing from "./shopHalfRing.vue";
import fileConfigData from "@/views/interactiveMarketing/acitivityReview/data.js";
import prizeList from "./prizeList.vue";
import generate from "@/components/generate_report.vue";
import aiToolsBtn from "@/components/ai/aiToolsBtn.vue";
import numberAnimation from "@/components/number-animation.vue";
import { getDecimalPlaces } from "@/utils/util2.js";
export default {
  name: "acitivity_review",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  created() {
    this.openCardConversionConfigData = this.initConfigData([
      {
        name: "入会数据",
        propertyList: [
          {
            label: "新增入会数",
            prop: "newMemberCount",
            checked: true,
            tips: "活动新入会的用户数",
          },
          {
            label: "入会率",
            prop: "memberRate",
            checked: false,
            tips: "新增入会人数/活动UV",
          },
        ],
      },
      {
        name: "转化数据",
        propertyList: [
          {
            label: "新增会员付款人数",
            prop: "newMemberPayUserCount",
            checked: false,
            lineIndex: 1,
            tips: "活动中新入会且有付款的用户数",
          },
          {
            label: "新增会员付款订单数",
            prop: "newMemberPayOrderCount",
            checked: false,
            lineIndex: 1,
            tips: "活动中新入会用户的付款订单数",
          },
          {
            label: "新增会员付款金额",
            prop: "newMemberPayAmount",
            checked: false,
            lineIndex: 1,
            tips: "活动中新入会用户的付款订单金额（pop为实付金额，自营为订单金额）",
          },
          {
            label: "新增会员客单价（付款）",
            prop: "newMemberPayCustomerPrice",
            checked: false,
            lineIndex: 1,
            tips: "新增会员付款金额/新增入会人数",
          },
          {
            label: "新增会员完成订单人数",
            prop: "newMemberCompleteUserCount",
            checked: false,
            lineIndex: 2,
            tips: "活动中新入会且有完成订单的用户数",
          },
          {
            label: "新增会员完成订单数",
            prop: "newMemberCompleteOrderCount",
            checked: false,
            lineIndex: 2,
            tips: "活动中新入会用户的完成订单数",
          },
          {
            label: "新增会员完成金额",
            prop: "newMemberCompleteAmount",
            checked: false,
            lineIndex: 2,
            tips: "活动中新入会用户的完成订单金额",
          },
          {
            label: "新增会员客单价（完成）",
            prop: "newMemberCompleteCustomerPrice",
            checked: false,
            lineIndex: 2,
            tips: "新增会员完成金额/新增会员完成金额/新增入会人数",
          },
        ],
      },
    ]);
    this.activityOverviewConfigData = this.initConfigData(
      fileConfigData.filter((item) => item.name != "活动信息"),
    );
    this.getyunqiStatsPrizeList();
    let ruleInfo = {};
    if (this.rowData.ruleInfo) {
      ruleInfo = JSON.parse(this.rowData.ruleInfo);
    }
    const activityType = this.rowData.activityType;
    let orderStartTime = "";
    let orderEndTime = "";
    if (activityType == 52) {
      // 试用回购礼
      orderStartTime = ruleInfo.trialRule.orderStartTime;
      orderEndTime = ruleInfo.formalRule.orderEndTime;
    } else if (activityType == 46) {
      // 满额有礼
      if (ruleInfo.orderTimeType == 0) {
        orderStartTime = ruleInfo.orderStartTime;
        orderEndTime = ruleInfo.orderEndTime;
      } else {
        orderStartTime = this.rowData.startTime;
        orderEndTime = this.rowData.endTime;
      }
    } else if (activityType == 53 && ruleInfo.cycleInfoList) {
      // 购物打卡
      orderStartTime = ruleInfo.cycleInfoList[0].cycleStartTime;
      orderEndTime =
        ruleInfo.cycleInfoList[ruleInfo.cycleInfoList.length - 1].cycleEndTime;
    } else if ([45, 16, 17, 18, 36].includes(activityType)) {
      // 积分锁权/下单有礼/首单专享礼/复购有礼/打榜有礼
      orderStartTime = ruleInfo.orderStartTime;
      orderEndTime = ruleInfo.orderEndTime;
      if (activityType == 36) {
        if (ruleInfo.rankActivityType == 1) {
          if (
            ruleInfo.openCardRule.inviteType == 0 ||
            ruleInfo.openCardRule.orderTimeType == 2
          ) {
            orderStartTime = this.rowData.startTime;
            orderEndTime = this.rowData.endTime;
          } else {
            orderStartTime = ruleInfo.openCardRule.orderStartTime;
            orderEndTime = ruleInfo.openCardRule.orderEndTime;
          }
        }
      }
    } else if (activityType == 28 || activityType == 19) {
      // 预售抽奖/下单抽奖
      orderStartTime = ruleInfo.lotteryCondition.orderStartTime;
      orderEndTime = ruleInfo.lotteryCondition.orderEndTime;
    } else if (activityType == 27) {
      // 预售有礼
      orderStartTime = ruleInfo.orderStartTime;
      orderEndTime = ruleInfo.orderEndTime;
    } else {
      // 其他活动
      orderStartTime = this.rowData.startTime;
      orderEndTime = this.rowData.endTime;
    }
    this.activityOverviewInfo[1].startTime = orderStartTime;
    this.activityOverviewInfo[1].endTime = orderEndTime;
    this.activityOverviewInfo[0].options[0].startTime = this.rowData.startTime;
    this.activityOverviewInfo[0].options[0].endTime = this.rowData.endTime;
    this.defaultOrderStartTime = orderStartTime;
    this.defaultOrderEndTime = orderEndTime;
  },
  components: {
    qudao,
    statisticsItem,
    shopHalfRing,
    prizeList,
    generate,
    aiToolsBtn,
    numberAnimation,
  },
  data() {
    return {
      activeName: "prizeAnalysis",
      defaultOrderStartTime: "",
      defaultOrderEndTime: "",
      control: false,
      myCharts: null,
      queryType: "0",
      curIndex: "1",
      tabInfo: [
        { label: "活动概览", value: "1" },
        { label: "入会转化概览", value: "2" },
        { label: "奖品数据", value: "3" },
      ],
      targetUserInex: "0",
      targetList: [
        { name: "访问", value: "0" },
        { name: "参与", value: "1" },
        { name: "中奖", value: "2" },
      ],
      // 入会转化分析
      openCardConversionOverviewData: {},
      openCardConversionOverviewInfo: [
        {
          label: "统计活动入会后：",
          type: "Input",
          prop: "joinDays",
          append: "天内的订单",
          value: "30",
          style: { "box-shadow": "0 2px 8px rgba(0, 0.3, 0.1, 0)" },
        },
        {
          label: "订单金额：",
          prop: "orderAmountCompareValue",
          value: "",
          slot: "orderAmount",
          placeholder: "请输入",
        },
        {
          label: "订单金额：",
          prop: "orderAmountCompareType",
          value: "0",
          isHide: true,
        },
        {
          label: "订单金额：",
          prop: "orderAmountType",
          value: "1",
          isHide: true,
        },
        {
          label: "入会时间：",
          type: "DateRange",
          startKey: "startTime",
          endKey: "endTime",
          dateType: "datetime",
          defalutLimit: true,
          startTime: this.rowData.startTime,
          endTime: this.rowData.endTime,
        },
      ],
      openCardConversionOverviewParams: {
        joinDays: "",
        startTime: "",
        endTime: "",
        orderAmountType: "1",
        orderAmountCompareType: "0",
        orderAmountCompareValue: "",
        targetUser: "",
        activityId: this.rowData.id,
        activityType: this.rowData.activityType,
        queryType: "",
      },
      // 活动概览
      orderTrentReportList: [],
      activityOverviewData: {},
      activityOverviewLoading: false,
      activityOverviewParams: {
        startTime: "",
        endTime: "",
        orderStartTime: "",
        orderEndTime: "",
        activityId: this.rowData.id,
        activityType: this.rowData.activityType,
      },
      activityOverviewInfo: [
        {
          label: "统计时间：",
          prop: "daytime",
          type: "btnCustomDate",
          value: 99,
          noShowTime: false,
          disabled: true,
          defaultStartDate: this.rowData.startTime,
          options: [
            { label: "活动期间", value: 99 },
            { label: "近7天", value: 1, day: 7 },
            { label: "近15天", value: 2, day: 15 },
            { label: "近30天", value: 3, day: 30 },
            {
              label: "自定义",
              value: 4,
              custom: true,
              dateType: "datetime",
              startTime: "",
              endTime: "",
              startKey: "startTime",
              endKey: "endTime",
              pickerOptionsStart: (startTime, endTime) => {
                return {
                  disabledDate: (time) => {
                    return (
                      time.getTime() <
                        new Date(this.rowData.startTime).getTime() -
                          24 * 60 * 60 * 1000 ||
                      time.getTime() > new Date(endTime).getTime()
                    );
                  },
                };
              },
              pickerOptionsEnd: (startTime, endTime) => {
                return {
                  disabledDate: (time) => {
                    return (
                      time.getTime() <
                      new Date(startTime).getTime() + 24 * 60 * 60 * 1000
                    );
                  },
                };
              },
            },
          ],
        },
        {
          label: "下单时间：",
          type: "DateRange",
          startKey: "orderStartTime",
          endKey: "orderEndTime",
          dateType: "datetime",
          startTime: "",
          endTime: "",
          defalutLimit: true,
          disabled: true,
        },
      ],
      openCardConversionConfigData: [],
      activityOverviewConfigData: [],
      prizeList: [],
      prizeOverviewQueryDTO: {
        activityType: this.rowData.activityType,
        activityId: this.rowData.id,
        targetUser: "",
        queryType: "",
      },
    };
  },
  watch: {},
  computed: {
    AnalysisDataList() {
      let propertyList = [];
      fileConfigData.forEach((v) => {
        propertyList.push(...v.propertyList);
      });
      propertyList = propertyList.map((v) => ({
        ...v,
        label: v.name || v.label,
      }));
      return [
        {
          id: "refundAnalysis",
          title: "退款分析",
          data: [
            {
              data: propertyList.find((v) => v.prop == "refundRate"),
              icon: "https://cdn-image.yucrm.cn//hd/images/13315956_fa40d09c3bd7406b8d2b80715c4fce54.png",
              isShowCharts: true,
              color: "#4981F0",
            },
            {
              data: propertyList.find((v) => v.prop == "refundUserCount"),
            },
            {
              data: propertyList.find((v) => v.prop == "refundOrderCount"),
            },
            {
              data: propertyList.find((v) => v.prop == "refundAmount"),
            },
            {
              data: propertyList.find((v) => v.prop == "refundProductCount"),
            },
          ],
        },
        {
          id: "productAnalysis",
          title: "商品分析",
          data: [
            {
              data: propertyList.find((v) => v.prop == "productViewRate"),
              icon: "https://cdn-image.yucrm.cn//hd/images/13315956_0d8d81521b764744826c1fb309a0c8d1.png",
              isShowCharts: true,
              color: "#4981F0",
            },
            {
              data: propertyList.find((v) => v.prop == "productPv"),
            },
            {
              data: propertyList.find((v) => v.prop == "productUv"),
            },
          ],
        },
      ];
    },
    // 中奖分析数据
    prizeAnalysisData() {
      let propertyList = [];
      fileConfigData.forEach((v) => {
        propertyList.push(...v.propertyList);
      });
      propertyList = propertyList.map((v) => ({
        ...v,
        label: v.name || v.label,
      }));
      return [
        {
          data: {
            label: "中奖率",
            prop: "winRate",
            tips: "中奖人数/参与人数*100%",
          },
          color: "#62D3D9",
          children: [
            propertyList.find((v) => v.prop == "winUserCount"),
            propertyList.find((v) => v.prop == "winCount"),
          ],
        },
        {
          data: {
            label: "填写率",
            prop: "addressFillRate",
            tips: "已填写地址人数/实物中奖人数*100%",
          },
          color: "#FB8066",
          children: [
            propertyList.find((v) => v.prop == "addressFilledUserCount"),
            propertyList.find((v) => v.prop == "addressNotFilledUserCount"),
          ],
        },
      ];
    },
    // 店铺分析半环形图 — 从活动概览接口数据映射
    shopAnalysisList() {
      let propertyList = [];
      fileConfigData.forEach((v) => {
        propertyList.push(...v.propertyList);
      });
      propertyList = propertyList.map((v) => ({
        ...v,
        label: v.name || v.label,
      }));
      // 配置：标题 + 接口字段 prop + 颜色
      const config = [
        {
          title: "店铺分析",
          prop: ["shopViewRate", "shopFollowRate"],
          color: ["#4A8BF5", "#EDBA4C"],
          propList: [
            "shopPv",
            "shopUv",
            "followShopUserCount",
            "followShopCount",
          ],
        },
        {
          title: "新老会员参与分析",
          prop: ["newMemberParticipateRate", "oldMemberParticipateRate"],
          color: ["#36CEC6", "#36CE94"],
          propList: [
            "newMemberParticipateCount",
            "newMemberParticipateUserCount",
            "oldMemberParticipateUserCount",
            "oldMemberParticipateCount",
          ],
        },
        {
          title: "意向分析",
          prop: ["orderCancelRate"],
          color: ["#FF9C62"],
          propList: [
            "notPayProductCount",
            "orderNotPayUserCount",
            "notPayAmount",
            "notPayOrderCount",
          ],
        },
      ];
      return config.map((c) => ({
        title: c.title,
        color: c.color,
        values: c.prop.map((v) =>
          propertyList.find((item) => item.prop == v)
            ? propertyList.find((item) => item.prop == v)
            : {},
        ),
        propList: c.propList.map((v) =>
          propertyList.find((item) => item.prop == v),
        ),
      }));
    },
    overviewConfigDataChart() {
      let propertyList = [];
      fileConfigData.forEach((v) => {
        propertyList.push(...v.propertyList);
      });
      propertyList = propertyList.map((v) => ({
        ...v,
        label: v.name || v.label,
      }));
      return [
        {
          title: "访客",
          titleImg:
            "https://cdn-image.yucrm.cn/f4efa93ad677496e8824e104b480e092.png",
          titleImgWidth: 248,
          titleImgHeight: 90,
          backgroundColor: "#F4F8FF",
          titleValue: propertyList.filter(
            (v) => v.prop == "activityParticipateRate",
          )[0],
          itemList: [
            "activityPv",
            "activityUv",
            "shareActivityCount",
            "shareActivityUserCount",
            "activityShareRate",
          ].map((v) => propertyList.find((item) => item.prop == v)),
        },
        {
          title: "参与",
          titleImg:
            "https://cdn-image.yucrm.cn/ef29a95b88ad4787a673cacabad05928.png",
          titleImgWidth: 208,
          titleImgHeight: 90,
          backgroundColor: "#EEFBFA",
          titleValue: {
            label: "参与_下单转化率",
            prop: "participateOrderConversionRate",
            tips: "下单人数/参与人数*100%",
          },
          itemList: [
            "participateCount",
            "participateUserCount",
            "participateNotWinCount",
            "participateWinCount",
          ].map((v) => propertyList.find((item) => item.prop == v)),
        },
        {
          title: "下单",
          titleImg:
            "https://cdn-image.yucrm.cn/413f857888e5424398de07ed037b16e8.png",
          titleImgWidth: 168,
          titleImgHeight: 90,
          backgroundColor: "#FFF7F4",
          titleValue: propertyList.filter(
            (v) => v.prop == "orderPayConversionRate",
          )[0],
          itemList: [
            "orderProductCount",
            "orderUserCount",
            "orderAmount",
            "orderCount",
            "orderCustomerPrice",
            "orderProductPrice",
          ].map((v) => propertyList.find((item) => item.prop == v)),
        },
        {
          title: "付款",
          titleImg:
            "https://cdn-image.yucrm.cn/9e002250379d47e0ad9ebb4a28fce98f.png",
          titleImgWidth: 128,
          titleImgHeight: 90,
          backgroundColor: "#FFF9FA",
          titleValue: {
            label: "付款-成交转化率",
            prop: "payCompleteConversionRate",
            tips: "成交人数/付款人数*100%",
          },
          itemList: [
            "payProductCount",
            "payUserCount",
            "payAmount",
            "payOrderCount",
            "payCustomerPrice",
            "payProductPrice",
          ].map((v) => propertyList.find((item) => item.prop == v)),
        },
        {
          title: "成交",
          titleImg:
            "https://cdn-image.yucrm.cn/b1aa292d2a9a48d6a3c2298a73d5cb3a.png",
          titleImgWidth: 88,
          titleImgHeight: 90,
          backgroundColor: "#FFFBFB",
          itemList: [
            "completeProductCount",
            "completeUserCount",
            "completeAmount",
            "completeOrderCount",
            "completeCustomerPrice",
            "completeProductPrice",
          ].map((v) => propertyList.find((item) => item.prop == v)),
        },
      ];
    },
    fileConfigData: {
      get() {
        let configData = [];
        if (this.curIndex == 1) {
          configData = this.activityOverviewConfigData;
        } else if (this.curIndex == 2) {
          configData = this.openCardConversionConfigData;
        }
        return configData;
      },
      set(val) {
        console.log(val);
        this.fileConfigData = val;
      },
    },
    trendCheckList() {
      let list = [];
      this.fileConfigData.forEach((item) => {
        item.propertyList.forEach((item2) => {
          if (item2.checked) {
            list.push(item2);
          }
        });
      });
      return list;
    },
  },
  methods: {
    getDecimalPlaces,
    handleClick2(e) {
      const name = e.name;
      if (!name) return;
      this.$nextTick(() => {
        const el = document.getElementById(name);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    },
    exportData(remark) {
      let data = {
        remark,
      };
      if (this.queryType == "0") {
        data.activityStatsOverviewQueryDTO = this.activityOverviewParams;
        data.openCardConversionOverviewQueryDTO =
          this.openCardConversionOverviewParams;
        data.prizeOverviewQueryDTO = this.prizeOverviewQueryDTO;
      } else {
        data.activityStatsOverviewQueryDTO =
          this.$refs.qudaoRef.activityOverviewParams;
        data.openCardConversionOverviewQueryDTO =
          this.$refs.qudaoRef.memberConversionParams;
        data.prizeOverviewQueryDTO = this.$refs.qudaoRef.prizeDataParams;
      }

      let targetUser = this.targetList[this.targetUserInex].value;
      data.activityStatsOverviewQueryDTO.targetUser = targetUser;
      data.openCardConversionOverviewQueryDTO.targetUser = targetUser;
      data.prizeOverviewQueryDTO.targetUser = targetUser;

      delete data.activityStatsOverviewQueryDTO.daytime;
      yunqiStatsExport(data).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: "导出成功",
            type: "success",
          });
        } else {
          this.$message.warning(res.message || "导出失败");
        }
      });
    },
    changeQueryType(val) {
      if (this.queryType == "0") {
        if (this.curIndex == 1) {
          this.getyunqiStatsActivityOverview();
        } else if (this.curIndex == 2) {
          this.getyunqiStatsOpenCardConversionOverview();
        }
      }
      if (this.curIndex == 3) {
        this.getyunqiStatsPrizeList();
      }
    },
    initConfigData(configData = []) {
      configData = JSON.parse(JSON.stringify(configData));
      const data = configData.map((v) => {
        let lineList = v.propertyList.filter((item) => {
          if (this.curIndex == 1) {
            if (
              item.label == "活动PV" ||
              item.label == "活动UV" ||
              item.label == "新增入会数"
            ) {
              item.checked = true;
            } else {
              item.checked = false;
            }
          }
          return item.lineIndex != undefined;
        });

        if (lineList.length == 0) {
          v.itemList = [v.propertyList];
        } else {
          v.itemList = [];
          lineList.forEach((item) => {
            if (v.itemList[item.lineIndex - 1] == undefined) {
              v.itemList[item.lineIndex - 1] = [item];
            } else {
              v.itemList[item.lineIndex - 1].push(item);
            }
          });
        }
        return v;
      });
      return data;
    },
    changeTargetUser(item, index) {
      this.targetUserInex = index;
      if (this.queryType == "0") {
        if (this.curIndex == 1) {
          this.getyunqiStatsActivityOverview();
        } else if (this.curIndex == 2) {
          this.getyunqiStatsOpenCardConversionOverview();
        }
      }
      if (this.curIndex == 3) {
        this.getyunqiStatsPrizeList();
      }
    },
    handleClick(index) {
      this.curIndex = index;
      if (this.queryType == "0") {
        if (this.curIndex == 1) {
          this.getyunqiStatsActivityOverview();
        } else if (this.curIndex == 2) {
          this.getyunqiStatsOpenCardConversionOverview();
        }
      }
      if (this.curIndex == 3) {
        this.getyunqiStatsPrizeList();
      }
    },
    getyunqiStatsPrizeList() {
      this.prizeOverviewQueryDTO.targetUser =
        this.targetList[this.targetUserInex].value;
      this.prizeOverviewQueryDTO.queryType = 0;
      let data = {
        ...this.prizeOverviewQueryDTO,
      };
      console.log(data);

      prizeSendOverview(data).then((res) => {
        if (res.code == 1) {
          this.prizeList = res.data || [];
        } else {
          this.$message.warning(res.message || res);
        }
      });
    },
    // 入会转化分析
    getyunqiStatsOpenCardConversionOverview() {
      this.openCardConversionOverviewParams.targetUser =
        this.targetList[this.targetUserInex].value;
      this.openCardConversionOverviewParams.queryType = this.queryType;
      let data = { ...this.openCardConversionOverviewParams };
      this.activityOverviewLoading = true;
      openCardConversionOverview(data)
        .then((res) => {
          this.activityOverviewLoading = false;
          if (res.code == 1) {
            this.openCardConversionOverviewData = res.data[0] || {};
          } else {
            this.$message.warning(res.message || res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.activityOverviewLoading = false;
        });
      if (this.curIndex == 2) {
        openCardConversionOverview({
          ...data,
          queryType: 2,
        })
          .then((res) => {
            this.activityOverviewLoading = false;
            if (res.code == 1) {
              this.orderTrentReportList = res.data || [];
              this.$nextTick(() => {
                this.myCharts = echarts.init(this.$refs.trendChart);
                this.initCharts();
              });
            } else {
              this.$message.warning(res.message || res);
            }
          })
          .catch((err) => {
            console.log(err);
            this.activityOverviewLoading = false;
          });
      }
    },
    openCardConversionOverviewReset() {
      this.openCardConversionOverviewParams.orderAmountType = "1";
      this.openCardConversionOverviewParams.orderAmountCompareType = "0";
      this.getyunqiStatsOpenCardConversionOverview();
    },
    // 活动概览
    getyunqiStatsActivityOverview() {
      this.activityOverviewParams.targetUser =
        this.targetList[this.targetUserInex].value;
      this.activityOverviewParams.queryType = this.queryType;
      let data = { ...this.activityOverviewParams };
      delete data.daytime;
      this.activityOverviewLoading = true;
      yunqiStatsActivityOverview(data)
        .then((res) => {
          this.activityOverviewLoading = false;
          if (res.code == 1) {
            this.activityOverviewData = res.data[0] || {};
          } else {
            this.$message.warning(res.message || res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.activityOverviewLoading = false;
        });
      yunqiStatsActivityOverviewTrend(data).then((res) => {
        if (res.code == 1) {
          this.orderTrentReportList = res.data || [];
          this.$nextTick(() => {
            this.myCharts = echarts.init(this.$refs.trendChart);
            this.initCharts();
          });
        } else {
          this.$message.warning(res.message || res);
        }
      });
    },
    initCharts() {
      let chartsOptions = {
        xAxis: {
          type: "category",
          data: [],
        },
        grid: {
          left: 0,
          right: 30,
          bottom: 43,
          containLabel: true,
        },
        legend: {
          data: [],
        },
        tooltip: {
          show: true,
          trigger: "axis",
        },
        color: ["#66A1FA", "#FFAA7A", "#a9be15", "#d8e4ff"],
        yAxis: {
          type: "value",
        },
        series: [],
      };
      let arr = [];
      if (this.curIndex == 1) {
        fileConfigData.forEach((v) => {
          arr.push(...v.propertyList);
        });
      } else if (this.curIndex == 2) {
        this.openCardConversionConfigData.forEach((v) => {
          arr.push(...v.propertyList);
        });
      }
      const series = this.trendCheckList.map((v) => {
        let series = {
          data: [],
          name: v.label,
          smooth: true,
          type: "line",
        };
        const keyItem = arr.find((e) => e.prop == v.prop) || {};
        if (keyItem) {
          series.data = this.orderTrentReportList.map((e) => {
            return e[keyItem.prop] || 0;
          });
          series.label = keyItem.label;
        }
        return series;
      });
      chartsOptions.series = series;
      chartsOptions.legend.data = series.map((v) => v.name);
      chartsOptions.xAxis.data = this.orderTrentReportList.map(
        (v) => v.trendDate,
      );
      this.myCharts.setOption(chartsOptions, true);
    },
    activityOverviewReset() {
      this.getyunqiStatsActivityOverview();
    },
  },
};
</script>

<style lang="scss" scoped>
.chart {
  width: 100%;
  height: 400px;
  margin-top: 20px;
}
.trend-analysis {
  width: 100%;
  height: 220px;
  margin-top: 16px;
  overflow-y: auto;
  border: 1px solid #ededed;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
  .trend-item {
    display: flex;
    .trend-item-content {
      flex: 1;
      padding: 8px 24px;
      border-bottom: 1px solid #ededed;
      .trend-item-content-item {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 8px 0;
        .trend-item-content-item-value {
          width: 12.5%;
        }
      }
    }
    .trend-item-title {
      width: 100px;
      padding: 16px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f6f7;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      border-bottom: 1px solid #ededed;
    }
  }
}
.target-box {
  display: flex;
  align-items: center;
  .active-target {
    color: #3159ff !important;
    border: 1px solid #3159ff !important;
  }
  .target-item {
    height: 30px;
    padding: 0 16px;
    text-align: center;
    border: 1px solid #dcdee1;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 30px;
    cursor: pointer;
    &:nth-child(1) {
      border-right: none;
      border-radius: 4px 0 0 4px;
    }
    &:nth-child(2) {
      border-right: none;
    }
    &:nth-child(3) {
      border-radius: 0px 4px 4px 0px;
    }
  }
}
.operate-wrap {
  display: flex;
  align-items: center;
  ::v-deep .ai-btn {
    margin-left: 12px;
  }
}
.overview-box {
  height: 754px;
  margin: 0 16px;
  display: flex;
  align-items: center;
  position: relative;
  .completeConversionRate-item {
    position: absolute;
    top: 130px;
    left: -45px;
    background: #fff;
    height: 57px;
    display: flex;
    align-items: center;
  }
  .payConversionRate-item {
    position: absolute;
    top: 280px;
    left: 58px;
    background: #fff;
    height: 57px;
    display: flex;
    align-items: center;
  }
  .orderCompleteConversionRate-item {
    position: absolute;
    top: 462px;
    left: 150px;
    background: #fff;
    height: 57px;
    display: flex;
    align-items: center;
  }
  .line-img {
    width: 350px;
    height: 690px;
  }
  .overview-content-row {
    display: flex;
    align-items: center;
    position: absolute;
    left: 350px;
    top: 0;
    .row-title {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      z-index: 99;
      .title-value {
        min-width: 200px;
        position: absolute;
        left: calc(50% + 16px);
        bottom: -12px;
        transform: translate(0, 100%);
      }
    }
    .overview-item-list {
      height: 90px;
      padding-left: 148px;
      flex: 1;
      display: flex;
      align-items: center;
      .overview-item {
        display: flex;
        align-items: center;
        &:nth-child(1) {
          .overview-item-values {
            width: 70px;
          }
        }
        &:nth-child(2) {
          .overview-item-values {
            width: 70px;
          }
        }
        &:nth-child(3) {
          .overview-item-values {
            width: 120px;
          }
        }
        &:nth-child(4) {
          .overview-item-values {
            min-width: 85px;
          }
        }
        &:nth-child(5) {
          .overview-item-values {
            min-width: 60px;
          }
        }
        .item-line {
          width: 0;
          height: 50px;
          margin: 0 50px;
          border: 1px solid #ededed;
        }
      }
    }
  }
  .overview-item-content {
    margin-top: 10px;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    line-height: 1;
    text-align: left;
  }
  .overview-item-title {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 13px;
    color: #666666;
  }
}
.prop-list {
  margin-top: 24px;
  padding: 24px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #eeeeee;
}
.prize-card {
  width: 622px;
  height: 195px;
  margin-top: 20px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #efefef;
}
.refundAnalysis-card {
  width: 300px;
  height: 96px;
  margin-top: 20px;
  margin-right: 16px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #efefef;
}
.charts-item {
  width: 306px;
  height: 96px;
  background: linear-gradient( 180deg, #F2F6FF 0%, rgba(242,246,255,0.15) 100%);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid transparent;
  border-image: linear-gradient(180deg, rgba(227, 232, 255, 1), rgba(227, 232, 255, 0)) 1 1;
}
::v-deep .activity-overview .el-card {
  box-shadow: none !important;
}

.participate-analysis {
  width: 374px;
  height: 151px;
  padding: 20px;
  background: #F6F9FF;
  border-radius: 6px 6px 6px 6px;
  &-title {
    font-weight: normal;
    font-size: 14px;
    color: #666666;
    text-align: left;
    font-style: normal;
    line-height: normal;
    text-transform: none;
  }
  &-content {
    margin-top: 14px;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  &-line {
    margin: 20px 0;
    width: 100%;
    height: 1px;
    border: 1px dashed #EBEBEF;
  }
  &-footer {
    display: flex;
    align-items: center;
    &_line {
      margin: 0 20px;
      width: 1px;
      height: 14px;
      background-color: #EBEBEF;
    }
  }
}
</style>
